/**
 * Wordmark — branded GLPFlo logotype used across all animated ad
 * variants. Renders "GLP" in a dark/neutral weight and "Flo" in a
 * variant-specific accent color, matching the static manifesto
 * design language.
 *
 * Props:
 *   size      = 'xl' | 'lg' | 'md'   (default 'xl')
 *   glpColor  = CSS color for "GLP"   (default white)
 *   floColor  = CSS color for "Flo"   (default purple gradient class)
 *   floClass  = optional Tailwind className override for "Flo"
 *   shadow    = optional text-shadow CSS for neon/retro variants
 */
import { motion } from "framer-motion";

const SIZES = {
  xl: "text-[110px] leading-none",
  lg: "text-[90px] leading-none",
  md: "text-[64px] leading-none",
};

export default function Wordmark({
  size = "xl",
  glpColor = "#FFFFFF",
  floColor,
  floClass,
  shadow,
  delay = 0,
  align = "center",
}) {
  const cls = SIZES[size] || SIZES.xl;
  const alignCls = align === "left" ? "text-left" : "text-center";
  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.7, ease: "easeOut" }}
      className={`font-black tracking-tight ${cls} ${alignCls}`}
      style={{ fontFamily: "'Outfit', 'Helvetica Neue', sans-serif", textShadow: shadow }}
    >
      <span style={{ color: glpColor }}>GLP</span>
      {floClass ? (
        <span className={floClass}>Flo</span>
      ) : (
        <span style={{ color: floColor || "#C4B5FD" }}>Flo</span>
      )}
    </motion.div>
  );
}
